import { useTranslation } from "react-i18next";

export function useFeedbackDialogText(
  t: ReturnType<typeof useTranslation>["t"],
) {
  return {
    title: t("board.feedback.title"),
    ratingLabel: t("board.feedback.ratingLabel"),
    descriptionLabel: t("board.feedback.descriptionLabel"),
    descriptionPlaceholder: t("board.feedback.descriptionPlaceholder"),
    sourceSuggestionDescriptionPlaceholder: t(
      "board.feedback.sourceSuggestionDescriptionPlaceholder",
    ),
    submitLabel: t("board.feedback.submitLabel"),
    cancelLabel: t("common.actions.cancel"),
    errorMessage: t("board.feedback.errorMessage"),
  };
}
